import clsx from 'clsx';
import { useState } from 'react';
import type { SafeAny } from '@trg/utils';
import { IconButton, type IconButtonProps } from '@trg/tlw-ui-component';
import { useAddToCartApi } from '../../api';
import { useProductCardContext } from './ProductCardContext';

export type AddToCartButtonProps = Omit<IconButtonProps, 'icon' | 'children'>;

export function AddToCartButton({
  className,
  onClick,
  ...props
}: AddToCartButtonProps) {
  const { catalog, currentSwatch, generateDataset } = useProductCardContext();

  const [isAddingToCart, setAddingToCart] = useState(false);

  const { mutate, isLoading } = useAddToCartApi({
    onSuccess() {
      setAddingToCart(true);
      setTimeout(() => setAddingToCart(false), 1500);
    },
  });

  const handleClick: IconButtonProps['onClick'] = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (isAddingToCart || isLoading) return;
    onClick?.(e as SafeAny);
    mutate({ productCodePost: currentSwatch.sku, qty: 1 });
  };

  return (
    <IconButton
      className={clsx(
        'tlw-text-txt-700/50 tlw-bg-white tlw-shadow-[0px_4px_4px_0px_#0000000D] enabled:hover:tlw-shadow-[0px_4px_8px_0px_#00000026] disabled:tlw-text-txt-400/50 lg:tlw-opacity-0 lg:group-hover/product-card:tlw-opacity-100',
        catalog && 'product__action__addToCart',
        className
      )}
      icon={isAddingToCart ? 'CartCheck' : 'Cart'}
      onClick={handleClick}
      {...props}
      {...generateDataset('addToCart')}
    />
  );
}
